<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousams"
            >&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="25"></md-layout>

          <md-layout md-flex>
            <h2>Importer Security Filing(ISF)</h2>
            <md-layout md-flex="45"></md-layout>
          </md-layout>
        </md-layout>

        <hr class="hr-border" />

        <md-layout md-gutter class="labelMargtop">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="30">
            <label for="fclConsoMultipleClientId">Client Name</label>
            <model-list-select
              :list="clientList"
              id="fclConsoMultipleClientId"
              v-model="amsFiligModal.fclConsoMultipleClientId"
              option-value="fclConsoMultipleClientId"
              option-text="clientName"
              placeholder="Select  Client Name"
              :isDisabled="amsFiligModal.conIsfId!=''"
            ></model-list-select>
            <!-- <span
              class="error"
              v-if="!amsFiligModal.fclConsoMultipleClientId"
            >{{errorList.fclConsoMultipleClientId}}</span>-->
          </md-layout>
        </md-layout>
        <div v-if="amsFiligModal.fclConsoMultipleClientId!='' ">
          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <h4>
                <u>Seller/Shipper Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="shipperName"
                  name="shipperName"
                  v-model="amsFiligModal.shipperName"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="25"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Tel/ Fax</label>
                <b-form-input :formatter="capitalizeAll"
                  id="shipperTelFax"
                  name="shipperTelFax"
                  v-model="amsFiligModal.shipperTelFax"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Street Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="shipperAddrs"
                  name="shipperAddrs"
                  v-model="amsFiligModal.shipperAddrs"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>City / Postal Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="cityPostalCode"
                  name="cityPostalCode"
                  v-model="amsFiligModal.cityPostalCode"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Country</label>
                <b-form-input :formatter="capitalizeAll"
                  id="shipperCountry"
                  name="shipperCountry"
                  v-model="amsFiligModal.shipperCountry"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Manufracturer( Or Suppliers) Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label for="manufracturer">Manufracturer(Suppliers)</label>
              <model-list-select
                :list="manufracturerList"
                id="manufracturer"
                v-model="amsFiligModal.manufracturer"
                option-value="manufracturerVal"
                option-text="manufracturerTxt"
                placeholder="Select Manufracturer"
                :isDisabled="amsFiligModal.blType=='liner'"
              ></model-list-select>
            </md-layout>
          </md-layout>
          <md-layout
            gutter
            class="labelMargtop"
            v-if="amsFiligModal.manufracturer!='Others' && amsFiligModal.manufracturer!=''"
          >
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <label>{{amsFiligModal.manufacturerLabel}}</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.manufacturerAll"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr" v-if="amsFiligModal.manufracturer=='Others'">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="manuOtherName"
                  name="manuOtherName"
                  v-model="amsFiligModal.manuOtherName"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr" v-if="amsFiligModal.manufracturer=='Others'">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Street Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="manuOthersAddrs"
                  name="manuOthersAddrs"
                  v-model="amsFiligModal.manuOthersAddrs"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout class="gutr" md-gutter v-if="amsFiligModal.manufracturer=='Others'">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>City / Postal Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="manuOthersCityPostal"
                  name="manuOthersCityPostal"
                  v-model="amsFiligModal.manuOthersCityPostal"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Country</label>
                <b-form-input :formatter="capitalizeAll"
                  id="manuOthersCountrt"
                  name="manuOthersCountrt"
                  v-model="amsFiligModal.manuOthersCountrt"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Tel/ Fax</label>
                <b-form-input :formatter="capitalizeAll"
                  id="manuOthersTelFax"
                  name="manuOthersTelFax"
                  v-model="amsFiligModal.manuOthersTelFax"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Importer Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label for="Importer">Importer</label>
              <model-list-select
                :list="manufracturerList"
                id="Importer"
                v-model="amsFiligModal.ImporterInfo"
                option-value="manufracturerVal"
                option-text="manufracturerTxt"
                placeholder="Select Importer"
                :isDisabled="amsFiligModal.blType=='liner'"
              ></model-list-select>
            </md-layout>
          </md-layout>
          <md-layout
            gutter
            class="labelMargtop"
            v-if="amsFiligModal.ImporterInfo!='Others' && amsFiligModal.ImporterInfo!=''"
          >
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <label>{{amsFiligModal.importerLabel}}</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.importerAll"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr" v-if="amsFiligModal.ImporterInfo=='Others'">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="impOtherName"
                  name="impOtherName"
                  v-model="amsFiligModal.impOtherName"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr" v-if="amsFiligModal.ImporterInfo=='Others'">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Street Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="impOthersAddrs"
                  name="impOthersAddrs"
                  v-model="amsFiligModal.impOthersAddrs"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout class="gutr" md-gutter v-if="amsFiligModal.ImporterInfo=='Others'">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>City / Postal Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="impOthersCityPostal"
                  name="impOthersCityPostal"
                  v-model="amsFiligModal.impOthersCityPostal"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Country</label>
                <b-form-input :formatter="capitalizeAll"
                  id="impOthersCountrty"
                  name="impOthersCountry"
                  v-model="amsFiligModal.impOthersCountry"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Tel/ Fax</label>
                <b-form-input :formatter="capitalizeAll"
                  id="impOthersTelFax"
                  name="impOthersTelFax"
                  v-model="amsFiligModal.impOthersTelFax"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>

          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Buyer Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label for="Buyer">Buyer</label>
              <model-list-select
                :list="manufracturerList"
                id="Buyer"
                v-model="amsFiligModal.BuyerInfo"
                option-value="manufracturerVal"
                option-text="manufracturerTxt"
                placeholder="Select Buyer"
                :isDisabled="amsFiligModal.blType=='liner'"
              ></model-list-select>
            </md-layout>
          </md-layout>
          <md-layout
            gutter
            class="labelMargtop"
            v-if="amsFiligModal.BuyerInfo!='Others' && amsFiligModal.BuyerInfo!=''"
          >
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <label>{{amsFiligModal.buyerLabel}}</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.buyerAll"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>
          <div v-if="amsFiligModal.BuyerInfo=='Others'">
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="buyerrName"
                    name="buyerrName"
                    v-model="amsFiligModal.buyerrName"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" v-if="amsFiligModal.BuyerInfo=='Others'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <md-layout md-flex="100">
                  <label>Street Address</label>
                  <b-form-textarea :formatter="capitalizeAll"
                    id="buyerOthersAddrs"
                    name="buyerOthersAddrs"
                    v-model="amsFiligModal.buyerOthersAddrs"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout class="gutr" md-gutter v-if="amsFiligModal.BuyerInfo=='Others'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>City / Postal Code</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="buyerOthersCityPostal"
                    name="buyerOthersCityPostal"
                    v-model="amsFiligModal.buyerOthersCityPostal"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Country</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="buyerOthersCountry"
                    name="buyerOthersCountry"
                    v-model="amsFiligModal.buyerOthersCountry"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Tel/ Fax</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="buyerOthersTelFax"
                    name="buyerOthersTelFax"
                    v-model="amsFiligModal.buyerOthersTelFax"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
          </div>

          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Consignee Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <label for="Buyer">Consignee</label>
              <model-list-select
                :list="manufracturerList"
                id="Buyer"
                v-model="amsFiligModal.consigneeInfo"
                option-value="manufracturerVal"
                option-text="manufracturerTxt"
                placeholder="Select Consignee"
                :isDisabled="amsFiligModal.blType=='liner'"
              ></model-list-select>
            </md-layout>
          </md-layout>
          <md-layout
            gutter
            class="labelMargtop"
            v-if="amsFiligModal.consigneeInfo!='Others' && amsFiligModal.consigneeInfo!=''"
          >
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <label>{{amsFiligModal.consigneeLabel}}</label>
              <quill-editor
                ref="myTextEditor"
                v-model="amsFiligModal.consigneeAll"
                :options="editorOption"
              ></quill-editor>
            </md-layout>
          </md-layout>

          <div v-if="amsFiligModal.consigneeInfo=='Others'">
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <md-layout md-flex="100">
                  <label>Name</label>
                  <b-form-input :formatter="capitalizeAll" id="conName" name="conName" v-model="amsFiligModal.conName"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr" v-if="amsFiligModal.consigneeInfo=='Others'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <md-layout md-flex="100">
                  <label>Street Address</label>
                  <b-form-textarea :formatter="capitalizeAll"
                    id="consigneeOthersAddrs"
                    name="consigneeOthersAddrs"
                    v-model="amsFiligModal.consigneeOthersAddrs"
                  ></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout class="gutr" md-gutter v-if="amsFiligModal.consigneeInfo=='Others'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>City / Postal Code</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="consigneeOthersCityPostal"
                    name="consigneeOthersCityPostal"
                    v-model="amsFiligModal.consigneeOthersCityPostal"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Country</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="consigneeOthersCountry"
                    name="consigneeOthersCountry"
                    v-model="amsFiligModal.consigneeOthersCountry"
                  ></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="30">
                <md-layout md-flex="100">
                  <label>Tel/ Fax</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="consigneeOthersTelFax"
                    name="consigneeOthersTelFax"
                    v-model="amsFiligModal.consigneeOthersTelFax"
                  ></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
          </div>
          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Consolidator Or Booking Agent Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorName"
                  name="consolidatorName"
                  v-model="amsFiligModal.consolidatorName"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Street Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="consolidatorAddrs"
                  name="consolidatorAddrs"
                  v-model="amsFiligModal.consolidatorAddrs"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>City / Postal Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorCityPostal"
                  name="consolidatorCityPostal"
                  v-model="amsFiligModal.consolidatorCityPostal"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Country</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorCountry"
                  name="consolidatorCountry"
                  v-model="amsFiligModal.consolidatorCountry"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Tel/ Fax</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorTelFax"
                  name="consolidatorTelFax"
                  v-model="amsFiligModal.consolidatorTelFax"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Container Stuffing Location Details</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorName"
                  name="consolidatorName"
                  v-model="amsFiligModal.containerStuffingName"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="90">
              <md-layout md-flex="100">
                <label>Street Address</label>
                <b-form-textarea :formatter="capitalizeAll"
                  id="consolidatorAddrs"
                  name="consolidatorAddrs"
                  v-model="amsFiligModal.containerStuffingAddrs"
                ></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>City / Postal Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorCityPostal"
                  name="consolidatorCityPostal"
                  v-model="amsFiligModal.containerStuffingCityPostal"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Country</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorCountry"
                  name="consolidatorCountry"
                  v-model="amsFiligModal.containerStuffingCountry"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>Tel/ Fax</label>
                <b-form-input :formatter="capitalizeAll"
                  id="consolidatorTelFax"
                  name="consolidatorTelFax"
                  v-model="amsFiligModal.containerStuffingTelFax"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Other Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <md-layout md-flex="100">
                <label>Country of Manufracturer</label>
                <b-form-input :formatter="capitalizeAll"
                  id="countryOrigin"
                  name="countryOrigin"
                  v-model="amsFiligModal.countryOrigin"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Purchase Order(PO)</label>
                <b-form-input :formatter="capitalizeAll" id="consopo" name="consopo" v-model="amsFiligModal.consopo"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>HTS Code</label>
                <b-form-textarea :formatter="capitalizeAll" id="htsCode" name="htsCode" v-model="amsFiligModal.htsCode"></b-form-textarea>
              </md-layout>
            </md-layout>
          </md-layout>
          <hr class="hr-border" />
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <h4>
                <u>Shipping Information</u>
              </h4>
            </md-layout>
          </md-layout>
          <md-layout md-gutter>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="35">
              <md-layout md-flex="100">
                <label>Carrier Name</label>
                <b-form-input :formatter="capitalizeAll"
                  id="CarrierName"
                  name="CarrierName"
                  v-model="amsFiligModal.CarrierName"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <md-layout md-flex="100">
                <label>Booking No.</label>
                <b-form-input :formatter="capitalizeAll" id="bookingNo" name="bookingNo" v-model="amsFiligModal.bookingNo"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Carrier MBL SCAC Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="mblScacCode"
                  name="mblScacCode"
                  v-model="amsFiligModal.mblScacCode"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="20">
              <md-layout md-flex="100">
                <label>Master Bill of Landing</label>
                <b-form-input :formatter="capitalizeAll"
                  id="masterBillLanding"
                  name="masterBillLanding"
                  v-model="amsFiligModal.masterBillLanding"
                ></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="15">
              <md-layout md-flex="100">
                <label>AMS SCAC Code</label>
                <b-form-input :formatter="capitalizeAll"
                  id="amsScacCode"
                  name="amsScacCode"
                  v-model="amsFiligModal.amsScacCode"
                ></b-form-input>
              </md-layout>
            </md-layout>

            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="15">
              <md-layout md-flex="100">
                <label>AMS No./HBL No.</label>
                <b-form-input :formatter="capitalizeAll" id="amsNo" name="amsNo" v-model="amsFiligModal.amsNo"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Container No.</label>
                <b-form-input :formatter="capitalizeAll"
                  id="containerNumber"
                  name="containerNumber"
                  v-model="amsFiligModal.containerNumber"
                ></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <md-layout md-gutter class="gutr">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>Vessel/Mother Vsl/Voy</label>
                <b-form-input :formatter="capitalizeAll" id="vesselVoy" name="vesselVoy" v-model="amsFiligModal.vesselVoy"></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <md-layout md-flex="100">
                <label>ETD Mother Vessel/LoadPort</label>
                <b-form-input :formatter="capitalizeAll"
                  id="etdloadPort"
                  name="etdloadPort"
                  v-model="amsFiligModal.etdloadPort"
                ></b-form-input>
              </md-layout>
            </md-layout>
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="30">
              <md-layout md-flex="100">
                <label>ETA at POD</label>
                <b-form-input :formatter="capitalizeAll" id="etaPod" name="etaPod" v-model="amsFiligModal.etaPod"></b-form-input>
              </md-layout>
            </md-layout>
          </md-layout>
          <hr class="hr-border" />

          <md-layout md-gutter>
            <md-layout md-flex="40"></md-layout>
            <md-layout md-flex="20">
              <md-button
                class="md-raised md-primary md-button-color md-theme-default back heght-1px"
                id="addButtonLoaderSubmit"
                @click="addIsf"
              >{{amsFiligModal.conIsfId==''?'Submit':'Update'}}</md-button>
              <md-spinner md-indeterminate id="loaderSubmit" style="display:none"></md-spinner>
            </md-layout>
          </md-layout>
        </div>
        <hr class="hr-s" />

        <div class="box-body" v-if="ifsTableArry.length>0">
          <div class="box-header">
            <h3 class="box-title">
              <u>ISF Details</u>
            </h3>
          </div>
          <table id="clientSB" class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Sr No.</th>
                <th>Client Name</th>
                <th>Manufracturer Info</th>
                <th>Inporter Info</th>
                <th>Buyer Info</th>
                <th>Consignee Info</th>
                <th>Download Word</th>

                <!-- <th>Print</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,index) in ifsTableArry" :key="index">
                <td>{{index+1}}</td>
                <td class="showMoreData" @click="viewEditIsf(item)">{{item.shipperName}}</td>
                <td>{{(item.manufracturer=='ConsigneeName')?'Consignee':item.manufracturer}}</td>
                <td>{{(item.ImporterInfo=='ConsigneeName')?'Consignee':item.ImporterInfo}}</td>
                <td>{{(item.BuyerInfo=='ConsigneeName')?'Consignee':item.BuyerInfo}}</td>
                <td>{{(item.consigneeInfo=='ConsigneeName')?'Consignee':item.consigneeInfo}}</td>
                <td>
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="downloadWord(item.conIsfId)"
                  >
                    <md-icon>cloud_download</md-icon>
                  </md-button>
                </td>
                <!-- <td>
                  <md-button
                    class="md-icon-button md-raised md-dense"
                    @click="Print(item.uploadBLCon)"
                  >
                    <md-icon>print</md-icon>
                  </md-button>
                </td>-->
              </tr>
            </tbody>
          </table>
        </div>
      </md-card-content>
    </md-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="alertSubmit"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopError"></md-dialog-alert>

    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE , URL_BASE_DOC } from "../../helper/constant.js";
import {DateFormat, selectDateFormat} from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/isfForm");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  data() {
    return {
      editorOption: {
        modules: {}
      },
      editorContent: "",
      isLoading: false,

      manufracturerList: [
        {
          manufracturerVal: "ConsigneeName",
          manufracturerTxt: "Consignee Name"
        },
        {
          manufracturerVal: "FirstNotify",
          manufracturerTxt: "First Notify"
        },
        {
          manufracturerVal: "SecondNotify",
          manufracturerTxt: "Second Notify "
        },
        {
          manufracturerVal: "Others",
          manufracturerTxt: "Others"
        }
      ],
      blTypeListISF: [
        {
          blTypeIsfVal: "Yes",
          blTypeIsfTxt: "Yes"
        },
        {
          blTypeIsfVal: "No",
          blTypeIsfTxt: "No"
        }
      ],

      errorList: {
        fclConsoMultipleClientId: ""
      },

      errorNames: {
        fclConsoMultipleClientId: "Select Client Name To Proceed"
      },

      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      getCLientData: [],
      getContainerArry: [],
      stuffingDataLiner: [],
      ifsTableArry: [],

      portLocationType: "",
      amsFiligModal: {
        conIsfId: "",
        manufacturerLabel: "",
        buyerLabel: "",
        importerLabel: "",
        consigneeLabel: "",
        manufacturerAll: "",
        importerAll: "",
        buyerAll: "",
        consigneeAll: "",
        blType: this.$sessionsStorage.get("blType"),
        ffType: this.$sessionsStorage.get("ffType"),
        fclConsoMultipleClientId: "",
        shipperName: "",
        shipperTelFax: "",
        shipperAddrs: "",
        cityPostalCode: "",
        shipperCountry: "",

        manufracturer: "",
        manuOtherName: "",
        manuOthersAddrs: "",
        manuOthersCityPostal: "",
        manuOthersCountrt: "",
        manuOthersTelFax: "",

        ImporterInfo: "",
        impOtherName: "",
        impOthersAddrs: "",
        impOthersCityPostal: "",
        impOthersCountry: "",
        impOthersTelFax: "",
        impOthersTelFax: "",

        BuyerInfo: "",
        buyerrName: "",
        buyerOthersAddrs: "",
        buyerOthersCityPostal: "",
        buyerOthersCountry: "",
        buyerOthersTelFax: "",

        consigneeInfo: "",
        consigneeOthersAddrs: "",
        consigneeOthersCityPostal: "",
        consigneeOthersCountry: "",
        consigneeOthersTelFax: "",

        consolidatorName: "",
        consolidatorAddrs: "",
        consolidatorCityPostal: "",
        consolidatorCountry: "",
        consolidatorTelFax: "",

        containerStuffingName: "",
        containerStuffingAddrs: "",
        containerStuffingCityPostal: "",
        containerStuffingCountry: "",
        containerStuffingTelFax: "",

        countryOrigin: "",
        consopo: "",
        htsCode: "",

        CarrierName: "",
        bookingNo: "",
        mblScacCode: "",
        masterBillLanding: "",
        amsScacCode: "",
        amsNo: "",
        containerNumber: "",
        vesselVoy: "",
        etdloadPort: "",
        etaPod: "",

        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        conFclBookingId: "",
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId")
      },

      validate: true
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },
  watch: {
    amsFiligModal: {
      handler: function(newVal, oldVal) {
        console.log("Here Change obj", newVal, oldVal);

        if (
          this.amsFiligModal.fclConsoMultipleClientId != "" &&
          this.amsFiligModal.blType == "house"
        ) {
          let checkAlready = this.ifsTableArry.filter(x => {
            return (
              x.fclConsoMultipleClientId ==
              this.amsFiligModal.fclConsoMultipleClientId
            );
          });

          if (checkAlready.length > 0 && this.amsFiligModal.conIsfId == "") {
            this.alert.content = checkAlready[0].shipperName + " Already Exist";
            this.$refs["addPopError"].open();
            this.amsFiligModal.fclConsoMultipleClientId = "";
          } else {
            let arrayClentId = this.getCLientData.filter(x => {
              return (
                x.fclConsoMultipleClientId ==
                this.amsFiligModal.fclConsoMultipleClientId
              );
            });

            if (arrayClentId.length > 0) {
              this.amsFiligModal.bookingNo = arrayClentId[0].bookingNo;
              this.amsFiligModal.masterBillLanding = arrayClentId[0].billLading;
              this.amsFiligModal.shipperName = arrayClentId[0].clientName;
              this.amsFiligModal.vesselVoy = arrayClentId[0].vesselVoy;

              let notifyArray = ["First", "Second", "Third", "Fourth", "Fifth"];
              let obj = {
                manufracturerTxt: "Consignee Name",
                manufracturerVal: "ConsigneeName",
                originalVal: arrayClentId[0].consignee
              };
              let arrayAll = [];
              arrayAll.push(obj);

              let notifyAr = arrayClentId[0].notifyList.split("$$$");

              notifyAr.map((x, index) => {
                let obj1 = {
                  manufracturerTxt: notifyArray[index] + " Notify",
                  manufracturerVal: notifyArray[index] + "Notify",
                  originalVal: x
                };
                arrayAll.push(obj1);
              });
              arrayAll.push({
                manufracturerTxt: "Others",
                manufracturerVal: "Others",
                originalVal: ""
              });

              this.manufracturerList = arrayAll;
            }

            if (this.amsFiligModal.manufracturer != "") {
              let arrayFilterNew = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.manufracturer;
              });

              if (arrayFilterNew.length > 0) {
                this.amsFiligModal.manufacturerLabel =
                  arrayFilterNew[0].manufracturerTxt;
                // this.amsFiligModal.manufacturerAll =
                //   arrayFilterNew[0].originalVal;
              }
            }
            if (this.amsFiligModal.ImporterInfo != "") {
              let arrayFilterImp = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.ImporterInfo;
              });

              if (arrayFilterImp.length > 0) {
                this.amsFiligModal.importerLabel =
                  arrayFilterImp[0].manufracturerTxt;
                this.amsFiligModal.importerAll = arrayFilterImp[0].originalVal;
              }
            }
            if (this.amsFiligModal.BuyerInfo != "") {
              let arrayFilterBuy = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.BuyerInfo;
              });

              if (arrayFilterBuy.length > 0) {
                this.amsFiligModal.buyerLabel =
                  arrayFilterBuy[0].manufracturerTxt;
                // this.amsFiligModal.buyerAll = arrayFilterBuy[0].originalVal;
              }
            }
            if (this.amsFiligModal.consigneeInfo != "") {
              let arrayFilterCon = this.manufracturerList.filter(x => {
                return x.manufracturerVal == this.amsFiligModal.consigneeInfo;
              });

              if (arrayFilterCon.length > 0) {
                this.amsFiligModal.consigneeLabel =
                  arrayFilterCon[0].manufracturerTxt;
                //this.amsFiligModal.consigneeAll = arrayFilterCon[0].originalVal;
              }
            }
            let arrayContainer = this.getContainerArry.filter(x => {
              return x.ffConExecutionId == this.amsFiligModal.ffConExecutionId;
            });

            if (arrayContainer.length > 0) {
              this.amsFiligModal.containerNumber =
                arrayContainer[0].fclConcontainerNo +
                "---" +
                arrayContainer[0].containerType;
            }
          }
        }
        if (
          this.amsFiligModal.fclConsoMultipleClientId != "" &&
          this.amsFiligModal.blType == "liner"
        ) {
          let checkAlready = this.ifsTableArry.filter(x => {
            return (
              x.fclConsoMultipleClientId ==
              this.amsFiligModal.fclConsoMultipleClientId
            );
          });

          if (checkAlready.length > 0 && this.amsFiligModal.conIsfId == "") {
            this.alert.content = checkAlready[0].shipperName + " Already Exist";
            this.$refs["addPopError"].open();
            this.amsFiligModal.fclConsoMultipleClientId = "";
          } else {
            let arrayClentIdLiner = this.getCLientData.filter(x => {
              return (
                x.fclConsoMultipleClientId ==
                this.amsFiligModal.fclConsoMultipleClientId
              );
            });

            if (arrayClentIdLiner.length > 0) {
              this.amsFiligModal.shipperName = arrayClentIdLiner[0].clientName;
            }

            let arrayDataOther = this.stuffingDataLiner.filter(x => {
              return (
                x.ffFclConsoExportId == this.amsFiligModal.ffFclConsoExportId
              );
            });
            console.log(arrayDataOther, "ijhkj");

            if (arrayDataOther.length > 0) {
              this.amsFiligModal.bookingNo = arrayDataOther[0].bookingNumber;
            }

            let arrayContainer = this.getContainerArry.filter(x => {
              return x.ffConExecutionId == this.amsFiligModal.ffConExecutionId;
            });

            if (arrayContainer.length > 0) {
              this.amsFiligModal.containerNumber =
                arrayContainer[0].fclConcontainerNo +
                "---" +
                arrayContainer[0].containerType;
            }
          }
        }
      },

      deep: true
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading
     CustomLoader,
  },

  computed: {
    clientList() {
      return this.getCLientData;
    }
  },

  methods: {
    downloadWord(id) {
      window.location =
        "http://164.52.196.219/pridelApiNew/Freight/consoIsIsfWord.php?id=" +
        id;
    },

    doLoading() {
      this.isLoading = true;
      // simulate AJAX
    },
    doLoadingClose() {
      this.isLoading = true;
      // simulate AJAX
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    oncloseBL() {},
    getData() {
      this.doLoading();
      let new_data = {
        ffType: this.$sessionsStorage.get("ffType"),
        blType: this.$sessionsStorage.get("blType")
      };

      new_data["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      new_data["ffConExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/getDataIFSConso.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            console.log(data);
            if (this.$sessionsStorage.get("blType") == "liner") {
              this.amsFiligModal.manufracturer = "Others";
              this.amsFiligModal.ImporterInfo = "Others";
              this.amsFiligModal.BuyerInfo = "Others";
              this.amsFiligModal.consigneeInfo = "Others";

              if (data.blLandingData.length > 0) {
                this.getCLientData = data.blLandingData;
              } else {
                this.getCLientData = [];
              }
            }
            if (this.$sessionsStorage.get("blType") == "house") {
              if (data.ConBLNonUsData.length > 0) {
                this.getCLientData = data.ConBLNonUsData;
                this.portLocationType = data.ConBLNonUsData[0].portLocationType;
              } else {
                this.getCLientData = [];
              }
            }

            if (data.containerData.length > 0) {
              this.getContainerArry = data.containerData;
            } else {
              this.getContainerArry = [];
            }
            if (data.stuffingData.length > 0) {
              this.stuffingDataLiner = data.stuffingData;
              this.portLocationType = data.stuffingData[0].portLocationType;
            } else {
              this.stuffingDataLiner = [];
            }
            if (data.conIsfData.length > 0) {
              this.ifsTableArry = data.conIsfData;
            } else {
              this.ifsTableArry = [];
            }

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },
    viewEditIsf(item) {
      // let arrayFilterAms = this.amsTableArry.filter(x => {
      //   return x.amsId == item.amsId;
      // });
      Object.keys(this.amsFiligModal).map((x, index) => {
        this.amsFiligModal[x] = item[x];
      });
    },
    // validateIsf() {
    //   let validate_new = true;
    //   Object.keys(this.errorList).map((x, index) => {
    //     if (this.amsFiligModal[x] == "") {
    //       this.errorList[x] = this.errorNames[x];
    //       validate_new = false;
    //     }
    //   });

    //   if (validate_new == true) {
    //     this.validate = true;
    //   } else {
    //     this.validate = false;
    //   }
    // },
    addIsf() {
      this.amsFiligModal["ffType"] = this.$sessionsStorage.get("ffType");
      this.amsFiligModal["blType"] = this.$sessionsStorage.get("blType");

      this.amsFiligModal["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.amsFiligModal["ffConExecutionId"] = this.$sessionsStorage.get(
        "editffConExecutionId"
      );

      // this.validateIsf();
      console.log(this.amsFiligModal);
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addConIfs.php`,
          data: JSON.stringify(this.amsFiligModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");

              if (this.amsFiligModal.conIsfId != "") {
                this.alert.content = "Data updated Successfully";
                this.$refs["alertSubmit"].open();
              } else {
                this.alert.content = "Data Added Successfully";
                this.$refs["alertSubmit"].open();
              }
              Object.keys(this.amsFiligModal).map(x => {
                this.amsFiligModal[x] = "";
              });

              this.getData();
              this.amsFiligModal["blType"] = this.$sessionsStorage.get(
                "blType"
              );
              this.amsFiligModal["ffType"] = this.$sessionsStorage.get(
                "ffType"
              );
              this.JqueryFun();
            }
          })
          .catch(error => {});
      }
    },

    previousams() {
      this.$router.push({
        path: "/ffExportCon/conAmsFilling"
      });
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// isfForm.vue?10d32190